/* RYNOR product page helpers (loaded once by sections/main-product.liquid)
   1. Drawers: Product details, Shipping details, Info drawer blocks
   2. Newsletter line: "Join our newsletter today" opens the Klaviyo form under it
   3. Bubble zoom cursor on the product photos (desktop mouse only); stays on while scrolling over photos
   One listener per event for the whole page, so everything keeps working after
   the theme editor re-renders the section. The ring size chart keeps its own script. */
(function () {
  if (window.__rynorPdp) return;
  window.__rynorPdp = true;

  /* 1 + 2: clicks */
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var drawerButton = target.closest('[data-rd-toggle]');
    if (drawerButton) {
      var row = drawerButton.closest('[data-rd]');
      if (!row) return;
      var panelId = drawerButton.getAttribute('aria-controls');
      var panel = (panelId && document.getElementById(panelId)) || row.querySelector('.rd__panel');
      var opening = drawerButton.getAttribute('aria-expanded') !== 'true';
      drawerButton.setAttribute('aria-expanded', opening ? 'true' : 'false');
      row.classList.toggle('is-open', opening);
      if (panel) panel.hidden = !opening;
      return;
    }

    var newsLink = target.closest('[data-rpdp-news-toggle]');
    if (newsLink) {
      event.preventDefault();
      var form = document.getElementById(newsLink.getAttribute('aria-controls'));
      if (!form) return;
      var show = form.hidden;
      form.hidden = !show;
      newsLink.setAttribute('aria-expanded', show ? 'true' : 'false');
      if (show) {
        var field = form.querySelector('input[type="email"], input');
        if (field) setTimeout(function () { try { field.focus({ preventScroll: true }); } catch (e) {} }, 60);
      }
    }
  });

  /* 3: bubble zoom cursor */
  var finePointer = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : null;
  // A real mouse (html.ry-mouse, layout/theme.liquid) counts too, even on PCs Chrome reports as touch-only.
  function noFinePointer() {
    return !!(finePointer && !finePointer.matches && !document.documentElement.classList.contains('ry-mouse'));
  }
  var bubble = null;
  var on = false;
  var frame = null;
  var check = null;
  var x = 0;
  var y = 0;
  var pointerKnown = false;

  function makeBubble() {
    if (bubble) return bubble;
    bubble = document.createElement('div');
    bubble.className = 'rpdp-zoom-bubble';
    bubble.setAttribute('aria-hidden', 'true');
    bubble.innerHTML = '<span class="rpdp-zoom-bubble__dot"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></span>';
    document.body.appendChild(bubble);
    return bubble;
  }
  function place() {
    frame = null;
    if (bubble) bubble.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0)';
  }
  function show() {
    if (on) return;
    on = true;
    makeBubble();
    place();
    bubble.classList.add('is-on');
    document.documentElement.classList.add('rpdp-zooming');
  }
  function hide() {
    if (!on) return;
    on = false;
    if (bubble) bubble.classList.remove('is-on', 'is-down');
    document.documentElement.classList.remove('rpdp-zooming');
  }
  // A photo, or the thin gap between photos, counts as "over a photo" so the + never flickers off between them.
  function overPhoto(el) {
    if (!el || !el.closest) return false;
    var area = el.closest('[data-rpdp-zoom-bubble]');
    if (!area) return false;
    if (el.closest('.js-zoom-img') || el.closest('.cc-product-gallery__media--image')) return true;
    if (el.classList.contains('cc-product-gallery__track')) return true;
    return el.classList.contains('cc-product-gallery__item') && !!el.querySelector('.cc-product-gallery__media--image');
  }

  function follow(event) {
    if (noFinePointer()) { hide(); return; }
    pointerKnown = true;
    x = event.clientX;
    y = event.clientY;
    if (overPhoto(event.target)) {
      if (!on) show();
      else if (!frame) frame = requestAnimationFrame(place);
    } else {
      hide();
    }
  }
  document.addEventListener('mousemove', follow, { passive: true });
  document.addEventListener('mouseover', follow, { passive: true });

  // Scrolling moves the page under a still mouse: keep the + while a photo is
  // under it (Scuffers style) and only drop it once the photos have scrolled away.
  function recheck() {
    check = null;
    if (!pointerKnown || noFinePointer()) return;
    if (overPhoto(document.elementFromPoint(x, y))) {
      if (!on) show();
    } else {
      hide();
    }
  }
  document.addEventListener('mousedown', function (event) {
    if (on && bubble && overPhoto(event.target)) bubble.classList.add('is-down');
  }, { passive: true });
  document.addEventListener('mouseup', function () {
    if (bubble) bubble.classList.remove('is-down');
  }, { passive: true });
  document.addEventListener('mouseleave', function () { pointerKnown = false; hide(); });
  window.addEventListener('blur', hide);
  window.addEventListener('scroll', function () {
    if (!check) check = requestAnimationFrame(recheck);
  }, { passive: true });
})();
